export default __webpack_public_path__ + "static/media/maranata_3.5aa73f93.jpg";